import { Reveal } from "@/components/site/Reveal";
import { IMAGES } from "@/data/content";
import { useContent } from "@/context/ContentContext";

export const Manifesto = () => {
  const { content } = useContent();
  const CHAPTERS = content.chapters;
  return (
  <section id="story" data-testid="manifesto" className="relative bg-[#f4f1ea] px-6 py-28 lg:px-10 lg:py-40">
    <div className="mx-auto max-w-[1400px]">
      <Reveal>
        <div className="overline mb-6">Our Story</div>
        <h2 className="max-w-4xl font-serif text-4xl font-medium leading-tight tracking-tight text-[#23281f] lg:text-6xl">
          Epic. Secluded. <span className="italic text-[#ba5a45]">Unforgettable.</span>
        </h2>
        <p className="mt-8 max-w-2xl text-lg leading-relaxed text-[#5c6157]">
          The Himalayas of India have satiated mankind's spiritual yearnings for millennia. Aruha is a
          pause within this wilderness — an alpine cafe and stay on the way to Kedarkantha, and a
          basecamp for journeys of discovery that fulfil every need you may have.
        </p>
      </Reveal>

      <div className="mt-20 grid gap-x-12 gap-y-16 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <div className="space-y-14">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.no} delay={i * 0.08}>
                <div className="flex gap-6 border-t border-[#ddd6c8] pt-8 lg:gap-10">
                  <span className="font-serif text-5xl leading-none text-[#c9bfa9] lg:text-7xl">{c.no}</span>
                  <div className="max-w-xl">
                    <h3 className="font-serif text-2xl text-[#23281f] lg:text-3xl">{c.title}</h3>
                    <p className="mt-3 leading-relaxed text-[#5c6157]">{c.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5">
          <Reveal delay={0.15}>
            <div className="group relative aspect-[3/4] overflow-hidden">
              <img
                src={IMAGES.cafe}
                alt="Aruha in the mountains"
                className="img-zoom h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1a1f18]/80 to-transparent" />
              <div className="absolute bottom-0 left-0 p-8">
                <div className="overline mb-2 text-[#e7d2ad]">A sanctuary within a sanctuary</div>
                <p className="font-serif text-2xl italic text-[#f6f3ec]">
                  958 sq. km of wild, bordering Tibet.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
  );
};
